<section class="form-container">    
    @if (cloneStarted$ | async) {
        <h1 class="form-title">Free Trial creation in progress</h1>
    } @else {
        <h1 class="form-title">Get Started with EcoOnline EHS</h1>
    }
    <div class="content-wrapper">
        @if (cloneStarted$ | async) {
            <div class="console-container">
                <mat-card>
                    <mat-card-content>
                        <p>Your trial is being created. This will take a few minutes to set up and you do not need to stay on this page. </p>
                        <p>If you wish to observe the progress then you can click the below link to open the logs in a new window. </p>
                        <p>This page will not update when the creation is complete - you will be able to find the tenant from the ACT homepage when it is ready. </p>
                        <mat-divider></mat-divider>
                    </mat-card-content>
                    <mat-card-actions>
                        <a mat-button target="_blank" rel="noopener noreferrer" [routerLink]="['/jobs', (cloneJobId$ | async)]">
                            VIEW CREATION LOGS
                        </a>
                    </mat-card-actions>
                    <mat-card-footer>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                    </mat-card-footer>
                </mat-card>
            </div>
        } @else {
            <app-new-tenant-trial-form (formSubmitted)="createTrial($event)"></app-new-tenant-trial-form>
        }
    </div>
</section>
